import i18n from "@/plugins/i18n";

export enum PriceModel {
	Standard = 0,
	Slow = 1,
	Express = 2,
}

export function getAllPriceModels() {
	return [
		{
			value: PriceModel.Standard,
			name: i18n.t("dtoLabels.priceModel.standard") as string,
		},
		{
			value: PriceModel.Slow,
			name: i18n.t("dtoLabels.priceModel.slow") as string,
		},
		{
			value: PriceModel.Express,
			name: i18n.t("dtoLabels.priceModel.express") as string,
		},
	];
}
